import { apiSlice } from '@/redux/api-slice'
import type {
  MediaToRefreshResults,
  StaleMediaPaginationRequest,
} from './types'

export const mediaManagementApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getStaleMedia: build.query<
      MediaToRefreshResults,
      StaleMediaPaginationRequest
    >({
      query: (request) => ({
        url: 'media/getStaleMedia',
        method: 'POST',
        body: request,
      }),
      providesTags: ['StaleMedia'],
    }),
    setMediaNonCurrent: build.mutation<void, number[]>({
      query: (mediaCodes) => ({
        url: 'media/NonCurrent',
        method: 'POST',
        body: mediaCodes,
      }),
      invalidatesTags: ['StaleMedia'],
    }),
    setMediaVerified: build.mutation<void, number[]>({
      query: (mediaCodes) => ({
        url: 'media/Verify',
        method: 'POST',
        body: mediaCodes,
      }),
      invalidatesTags: ['StaleMedia'],
    }),
    setMediaArchived: build.mutation<void, number[]>({
      query: (mediaCodes) => ({
        url: 'media/Archive',
        method: 'POST',
        body: mediaCodes,
      }),
      invalidatesTags: ['StaleMedia'],
    }),
  }),
})

export const {
  useGetStaleMediaQuery,
  useSetMediaNonCurrentMutation,
  useSetMediaVerifiedMutation,
  useSetMediaArchivedMutation,
} = mediaManagementApi
